export default __webpack_public_path__ + "static/media/photo_gallery_4.457e4b4d.png";